<!-- eslint-disable vue/no-unused-properties -->
<!-- 展示以及搜索订单收款记录 -->
<template>
  <div class="receiptWrap">
    <!-- 搜索区 -->
    <el-form :model="searchData">
      <QS-search maxLine="1">
        <el-form-item prop="state" label="收款状态">
          <el-select
            v-model="searchData.state"
            clearable
            placeholder="请选择收款状态"
          >
            <el-option
              v-for="item in receiptStateList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <template slot="moreBtn">
          <el-form-item>
            <el-button type="primary" @click="searchHandle"> 查询 </el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              @click="
                () => {
                  this.$refs['search'].resetFields()
                  this.searchHandle()
                }
              "
            >
              重置
            </el-button>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>

    <!-- 表格区 -->
    <div class="receiptWrap-tableWrap">
      <QS-common-table
        :loading="loading"
        class="mt16 receiptWrap-tableWrap-table"
        :pagination="pagination"
        :columns="m_receiptTableColumns"
        @change="paginationEvent"
        :data="dataList"
      >
      </QS-common-table>
    </div>

    <!-- 撤回弹窗 -->
    <dialogWrap
      title="是否撤回"
      v-model="showRevocationDialog"
      :append-to-body="true"
    >
      <p>确认撤回吗？撤回后会将收款变为作废状态，需要重新发起收款</p>

      <template slot="footer">
        <el-button
          size="small"
          @click="
            () => {
              this.showRevocationDialog = false
              this.revokeOrderID = ''
            }
          "
        >
          取消
        </el-button>
        <el-button type="primary" size="small" :loading="revokeLoading" @click="revokeRecord">
          确定
        </el-button>
      </template>
    </dialogWrap>
  </div>
</template>

<script>
import mixins from './mixins/index'
import selectOption from '@/store/dict/selectOptionDict'
import {
  getbatchCollectionRecordList,
  batchRecordRetract,
} from '@/api/financeApi'

export default {
  mixins: [mixins],
  data() {
    return {
      // 展示撤回询问弹窗
      showRevocationDialog: false,
      // 需要撤回的收款ID
      revokeOrderID: '',
      // 个人租赁订单ID
      rentOrderId: this.$route.query.id,
      searchData: {
        state: '',
      },
      dataList: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
      revokeLoading: false,
      // receiptTableColumns: tableColumns
    }
  },
  computed: {
    receiptStateList() {
      return this.dictParseList(selectOption.batchStateDict)
    },
  },
  mounted() {
    // 展示出列表内容
    this.fetchReceiptList()
  },
  methods: {
    searchHandle() {
      // 页码重置为1
      this.pagination.pageNum = 1
      this.fetchReceiptList()
    },
    // 获取收款列表内容
    async fetchReceiptList() {
      try {
        this.loading = true
        const { code, data } = await getbatchCollectionRecordList({
          ...this.searchData,
          // rentOrderId: this.rentOrderId,
          sourceOrderId: this.rentOrderId,
          sourceOrderType: 2, // 来源类型：2车辆租赁合同/7逾期收款单/100其他
          pageSize: this.pagination.pageSize,
          pageNum: this.pagination.pageNum,
        })
        this.loading = false
        if (code !== 1) return
        this.pagination.total = data.totalNum
        this.dataList = data.items
      } catch (err) {
        this.loading = false
      }
    },
    // 分页方法
    paginationEvent(payload) {
      const { pagination } = payload
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.pageNum
      this.fetchReceiptList()
    },
    // 跳转查看详情
    // eslint-disable-next-line vue/no-unused-properties
    viewDetail({ id }) {
      const { rentOrderId } = this
      this.$emit('close')
      this.$router.push({
        path: '/workbench/order/sub/collection/detail',
        query: {
          type: 'order',
          id,
          rentOrderId,
        },
      })
    },
    // 展示撤回收款弹窗
    // eslint-disable-next-line vue/no-unused-properties
    showRevokeDialog({ id }) {
      // 记录需要撤回的ID
      this.revokeOrderID = id
      this.showRevocationDialog = true
    },
    // 撤回收款记录
    async revokeRecord() {
      if (this.revokeLoading) return
      this.revokeLoading = true
      try {
        const { code } = await batchRecordRetract({
          bizId: this.revokeOrderID,
          state: 20,
          bizType: 1,
        })
        if (code === 1) {
          this.showRevocationDialog = false
          this.fetchReceiptList()
          this.$emit('revokeSuccess')
        }
      } finally {
        this.revokeLoading = false
      }
    },
  },
}
</script>

<style lang="scss">
.receiptWrap {
  &-tableWrap {
    width: 100%;
    overflow-x: scroll;
  }
}
</style>
